<template>
    <div>
    <section-header />
    
        <section class="about-section-two">
              <div class="auto-container">
                  <div class="inner-container">
                      <div class="row clearfix">
                          <!--Column-->
                          <div class="content-column col-md-6 col-sm-12 col-xs-12">
                              <div class="inner-content">
                                  <div class="text">
                                      <p>Page not found</p>
                                      <p>&nbsp;</p>
                                  </div>
                                
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
        </section>
        </div>
</template>

<script>
import SectionHeader from '@/components/SectionHeader.vue';

export default {
  name: 'Services',
  components: {
    SectionHeader
  },
  data() {
    return {
      content: ''
    };
  },
  computed: {
   currentPa() {
        return this.$router.history.current.name;
      },
  },
  mounted() {

  }
};
</script>